var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.952,
    height: 68,
    viewBox: "0 0 98.952 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "finance",
    transform: "translate(-6 -86.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M250.493,180.2a31.57,31.57,0,0,0-13.339-12.381",
    transform: "translate(-185.316 -64.685)",
    fill: "none",
    stroke: "#19d2d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M24.96,167.823a30.937,30.937,0,0,0-11.72,45.8,9.115,9.115,0,0,0,7.443,3.726h31.7",
    transform: "translate(0 -64.685)",
    fill: "none",
    stroke: "#19d2d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M105.975,92.8a2.474,2.474,0,0,0-3.389-3.286A9.136,9.136,0,0,1,97.7,90.757c-5.42,0-5.42-3.1-10.839-3.1s-5.416,3.1-10.832,3.1a9.106,9.106,0,0,1-4.86-1.236,2.474,2.474,0,0,0-3.39,3.286l5.166,10.332h27.857Z",
    transform: "translate(-48.425)",
    fill: "none",
    stroke: "#19d2d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x1: 10.833,
    y2: 18.571,
    transform: "translate(27.619 103.138)",
    fill: "none",
    stroke: "#19d2d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 10.833,
    y2: 18.571,
    transform: "translate(38.452 103.138)",
    fill: "none",
    stroke: "#19d2d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M296.794,398.465H273.58a1.548,1.548,0,0,1-1.548-1.548v-3.1a1.548,1.548,0,0,1,1.548-1.548h21.667a1.548,1.548,0,0,1,1.548,1.548Z",
    transform: "translate(-213.461 -245.803)",
    fill: "none",
    stroke: "#19d2d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M311.279,366.4H289.613a1.548,1.548,0,0,1-1.548-1.548v-3.1a1.548,1.548,0,0,1,1.548-1.548h21.667a1.548,1.548,0,0,1,1.548,1.548v3.1A1.548,1.548,0,0,1,311.279,366.4Z",
    transform: "translate(-226.398 -219.929)",
    fill: "none",
    stroke: "#19d2d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M295.246,334.336H273.58a1.548,1.548,0,0,1-1.548-1.548v-3.1a1.548,1.548,0,0,1,1.548-1.548h21.667a1.548,1.548,0,0,1,1.548,1.548v3.1A1.548,1.548,0,0,1,295.246,334.336Z",
    transform: "translate(-213.461 -194.055)",
    fill: "none",
    stroke: "#19d2d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M417.314,392.274v4.643a1.548,1.548,0,0,1-1.548,1.548H400.29",
    transform: "translate(-316.957 -245.803)",
    fill: "none",
    stroke: "#19d2d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M416.045,360.21h9.286a1.548,1.548,0,0,1,1.548,1.548v3.1a1.548,1.548,0,0,1-1.548,1.548H408.307",
    transform: "translate(-323.426 -219.929)",
    fill: "none",
    stroke: "#19d2d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M408.306,328.145h13.929a1.548,1.548,0,0,1,1.548,1.548v4.643",
    transform: "translate(-323.425 -194.055)",
    fill: "none",
    stroke: "#19d2d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M311.279,302.271H289.613a1.548,1.548,0,0,1-1.548-1.548v-3.1a1.548,1.548,0,0,1,1.548-1.548h21.667a1.548,1.548,0,0,1,1.548,1.548v3.1A1.548,1.548,0,0,1,311.279,302.271Z",
    transform: "translate(-226.398 -168.181)",
    fill: "none",
    stroke: "#19d2d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M295.246,270.207H273.58a1.548,1.548,0,0,1-1.548-1.548v-3.1a1.548,1.548,0,0,1,1.548-1.548h21.667a1.548,1.548,0,0,1,1.548,1.548v3.1A1.548,1.548,0,0,1,295.246,270.207Z",
    transform: "translate(-213.461 -142.307)",
    fill: "none",
    stroke: "#19d2d2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.d8ebf4c0f79e3c03356504100679e1a3.svg";
export { ForwardRef as ReactComponent };